import script from "./EmailsView.vue?vue&type=script&lang=ts&setup=true"
export * from "./EmailsView.vue?vue&type=script&lang=ts&setup=true"

import "./EmailsView.vue?vue&type=style&index=0&id=21fb9c70&lang=css"

const __exports__ = script;

export default __exports__